export default function Success() {
    return (
        <div>
            <h1>¡Pago exitoso!</h1>
            <p>¡Gracias por preferirnos!</p>
        </div>
    );
}
